module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av436-c5657b8a3c338d1e656eaa3ef88182c2.jpg";